module.exports = __webpack_public_path__ + "img/joanna_erbel.e028bb83.png";